import { Box, Grid } from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';

import { ApplicationRoutes } from '../../../../../application/constants/routes';
import { TranslateText } from '../../../../../application/language/TranslateText';
import { StudyReportNavbar } from '../../../../analytics/components/StudyReportNavbar';
import { AnalyticsPageHeader } from './parts/AnalyticsPageHeader';
import { StudyDashboardWrapper } from '../../../../analytics/components/StudyDashboardWrapper';

export const AnalyticsMainPage = observer(() => {
  return (
    <Grid container display={'flex'} flexDirection={'column'} width={'100%'} height={'100%'} minHeight={0}>
      <AnalyticsPageHeader
        breadcrumbs={[
          {
            label: <TranslateText i18nKey="analytics.title" />,
            link: ApplicationRoutes.Analytics,
          },
        ]}
        actions={<StudyReportNavbar />}
      />
      <Box
        sx={{
          mt: 2,
          flex: 1,
          minHeight: 0,
          overflow: 'hidden',
        }}
      >
        <StudyDashboardWrapper showReportNavbar={false} />
      </Box>
    </Grid>
  );
});
